import { Route, Redirect } from 'react-router-dom';
import {useAuth} from "../../contexts/AuthenticationContext";
import { ContractContextProvider } from '../../contexts/ContractContext';

export default function AuthRoute({ component: Component, ...rest }: any){
	const { session } = useAuth();

	return (
		<Route
			{...rest}
			render={props => {
				return session ? <ContractContextProvider><Component {...props} /></ContractContextProvider> : <Redirect to="/" />
			}}
		/>
	)
}
